<template>
  <svg width="19" height="19" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.5" cy="8.5" r="8" fill="white" stroke="var(--livi-primary)" />
    <circle cx="8.5" cy="8.5" r="4.5" fill="var(--livi-primary)" />
  </svg>
</template>
